module.exports = __webpack_public_path__ + "static/img/strona_008.fd0190a2.jpg";